export default "__VITE_ASSET__Cx5I5_Tn__"